<template>
	<div class="c-s z-ant-input" v-if="isShow" style="position: fixed;top: 0;height: 100vh;z-index: 999;">
		<div :show="isShow" @click="_click(false) " style="position: initial;background-color: rgba(0, 0, 0, 0.7);height: 100%;width: var(--theme-max-width);" z-index="4" >
			 <div class="wrapper" >
				<div style="">
					<div class="ant-modal-content" @click.stop>
							<div class="ant-modal-header"><div id="rcDialogTitle1" class="ant-modal-title">Add Account</div></div>
							<div class="ant-modal-body">
								<div class="gD0G2pAAJZZTJ1n0KQXv" >
									<!-- margin-bottom: .5rem; -->
									<antInput  :clearable='false' @onInput="_onInput" :modelValue="forData.account_name" form-key='account_name'
										:placeholder="$t('components._Introduzaoseunomereal')">
										<div slot="left"
											style="color: var(--theme-text-color-darken);font-size:.18rem;display: flex;align-items: center;">
											<svg-icon className="prefix"
												icon-class="input_icon_zsxm--svgSprite:all" />
										</div>
									</antInput>
								</div>
								<div class="gD0G2pAAJZZTJ1n0KQXv">
									<antS @_click="chooseType" :dados="['GCASH','BANK']" :modelvalue="accountType">
										<div slot="left-icon"
										style="color: var(--theme-text-color-darken);font-size:.18rem;display: flex;align-items: center;"
										>
										<svg style="width: .36rem;height: .36rem;" fill="currentColor" viewBox="0 0 16 16">
											<path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v1h14V4a1 1 0 0 0-1-1H2zm13 4H1v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7z"/>
											<path d="M2 10a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-1z"/>
										</svg>
										</div>
									</antS>
								</div>
								<div class="gD0G2pAAJZZTJ1n0KQXv" v-if="isBANK">
									<antS @_click="chooseBank" :dados="bankList" :modelvalue="nowBank" fontSizeClass="spanfontsize18">
										<div slot="left-icon" style="color: var(--theme-text-color-darken);font-size:.18rem;display: flex;align-items: center;" >
										<svg-icon className="prefix" icon-class="input_icon_bank--svgSprite:all" />
										</div>
									</antS>
								</div>
								<div class="gD0G2pAAJZZTJ1n0KQXv">
									<antInput type="number" maxlength="30" :modelValue="forData.account_cpf" @onInput="_onInput" :clearable='false' form-key='account_cpf'
										placeholder="Enter your account No.">
										<div slot="left"
											style="color: var(--theme-text-color-darken);font-size:.18rem;display: flex;align-items: center;">
											<svg style="vertical-align: -0.15em;width: .36rem;height: .36rem;" fill="currentColor" viewBox="0 0 16 16">
												<path fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm9 1.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5ZM9 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4A.5.5 0 0 1 9 8Zm1 2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Zm-1 2c0 .17-.014.337-.04.5H2a1 1 0 0 1-.984-.819C1.2 10.398 2.914 9 5 9c2.21 0 4 1.567 4 3.5ZM7 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"/>
											</svg>
										</div>
									</antInput>
								</div>
								<div class="Kw58s_FCuipHRV_EW4tG">
									<span>{{ $t('withdraw._Verifique') }} </span>
								</div>
								<div class="Pt3rGlTmq0_WLpTGHsA_" @click="setBank">
									<van-button class="JHBAn8W0jkHI1OM_X2fy" type="primary">{{ $t('withdraw._Confirmar') }}</van-button>
								</div>
							</div>
					</div>
				</div>
				
			</div>
		</div>
		
	</div>
</template>

<script>
	import {
		setBank
	} from "@/apis/modules/login.js"
	import antInput from "./input.vue"
	import antInputPassword from "@/components/ant-input-password/index.vue"
	import antS from "./ant-s.vue"
	import { Toast } from 'vant';
	export default{
		components:{
			antInputPassword,
			antInput,
			antS
		},
		props:{
			isShow:{
				type:Boolean,
				default: false,
			},
			formDta:{
				type:[Object],
				default:()=>{return {}},
				
			}
			
		},
		data() {
			return{
				show:true,
				isShowNum:false,
				shuruKOangName:'',
				accountType:0,
				nowBank:0,
				isBANK:false,
				forData:{
					account_name:'',
					account_pix:'',
					account_cpf:'',
					account_type:'GCASH',
				},
				bankList : [
					'Please select a bank',
					"Agribusiness Banking Corporation-A Rural Bank","Al-Amanah Islamic Invest. Bank","AllBank (A Thrift Bank), Inc.","ANZ Banking Group Ltd",
					"Asenso","Asia United Bank","BananaPay","Bangko Kabayan","Bangko Mabuhay","Bangko Nuestra Señora Del Pilar","Bangkok Bank - Manila Branch",
					"Bank of America, N.A. - Manila Branch","Bank of China","Bank of Commerce","Bank of Florida","Bank Of Makati (A Savings Bank), Inc.",
					"BanKo, A subsidiary of BPI","Bayad Center","Bayanihan Bank, Inc.","BDO Bank","BDO Network Bank","Binangonan Rural Bank (BRBDigital)",
					"Biñan Rural Bank, Inc.","BPI","Camalig Bank","Cantilan Bank","CARD Bank","CARD SME Bank","Cathay United Bank - Manila Branch",
					"Cebuana Lhuillier","Cebuana Lhuillier Bank/ Cebuana Xpress","China Bank","China Bank Savings","CIMB Bank Philippines","CIS Bayad Center/ Bayad",
					"Citibank, N.A. - Manila Branch","City Savings Bank","Cooperative Bank Of Quezon Province","CTBC Bank (Philippines) Corp.","DCPAY PHILIPPINES",
					"Deutsche Bank AG - Manila Branch","Development Bank of the Philippines","Dumaguete Bank","Dungganon Bank","EastWest Bank",
					"Easy Pay Global EMI Corp","Equicom Savings Bank","First Consolidated Bank","Gateway Rural Bank, Inc.","GCash","GoTyme Bank",
					"GrabPay","Guagua Rural Bank","HSBC","I-Remit/iCASH","Industrial and Commercial Bank of China Limited - Manila Branch",
					"Industrial Bank of Korea - Manila","Infoserve / Nationlink","Innovative Bank, Inc. (A Rural Bank)","ISLABANK",
					"JP Morgan Chase Bank, N.A - Manila Branch","JuanCash","KEB Hana Bank – Manila Branch","Komo/ EastWest Rural Bank",
					"Laguna Prestige Bank","LANDBANK / OFBank","Lazada Wallet (Alipay Ph.)","LBC Express","Legazpi Savings Bank",
					"LOLC Bank Philippines, Inc. A Thrift Bank","Lulu Money","Luzon Development Bank","M Lhuillier","Malarayat Rural Bank, Inc.",
					"Malayan Bank Savings","MarCoPay","MariBank","Maya Bank","Maybank","Mega Int'l Commercial Bank - Manila Branch","Metrobank",
					"Mindanao Consolidated CoopBank","Mizuho Bank, Ltd. – Manila Branch","Money Mall Rural Bank, Inc.","MUFG Bank, Ltd. - Manila Branch",
					"MVSM Bank (A Rural Bank Since 1953) Inc.[Marikina Valley San Mateo Bank]","NetBank","New Rural Bank Of San Leonardo (Nueva Ecija), Inc.",
					"Omnipay, Inc.","Own Bank","Palawan Pawnshop","PalawanPay","Partner Rural Bank (Cotabato), Inc.","PayMaya/ Maya Wallet","PayMongo","PBCOM",
					"PDAX","Peppermint Bizmoto Inc.","Pera Hub","Philippine Business Bank, Inc., A Savings Bank","Philippine Veterans Bank","PhilTrust Bank",
					"PNB","Producers Savings Bank Corporation","PSBank","Queenbank","Quezon Capital Rural Bank","Rang-Ay Bank","RBT Bank","RCBC / Diskartech",
					"RD Pawnshop","Robinsons Bank","Rural Bank of Angeles, Inc.","Rural Bank Of Bacolod City, Inc.","Rural Bank Of Bauang, Inc.",
					"Rural Bank of Digos","Rural Bank Of La Paz, Inc.","Rural Bank Of Lebak (Sultan Kudarat), Incorporated","Rural Bank of Mangaldan, Inc.",
					"Rural Bank of Montalban","Rural Bank Of Porac (Pampanga), Inc.","Rural Bank of Rosario (La Union), Inc.","Rural Bank Of Sagay, Inc.",
					"Rural Bank Of San Narciso, Inc.","Rural Bank of Silay City","Rural Bank of Sta. Ignacia","Security Bank","Shinhan Bank – Manila Branch",
					"ShopeePay","SMBC - Manila Branch","Southeast Country Bank, Inc.","SpeedyPay","Standard Chartered Bank","Starpay","Sterling Bank of Asia",
					"Summit Bank Rural Bank of Tublay, Inc.","Sun Savings Bank","TagCash Ltd. Inc.","TayoCash","Tonik Bank","TOP Bank Philippines, Inc. (A Rural Bank)",
					"TraxionPay/ DigiCOOP/ COOPNET","UCPB Savings Bank","Union Bank of the Philippines","UnionDigital Bank","United Overseas Bank Limited, Manila Branch ",
					"UNOBank","USSC","Vbank Rural Banking, Inc.","Villarica Pawnshop, Inc.","Wealth Bank","Wise Pilipinas, Inc.","Yuanta Bank","Zambales Rural Bank",
				],
			}
		},
		watch: {
		    // 当message变化时，这个函数就会被调用
		    isShow(newValue, oldValue) {
				this.forData = this.formDta.account_type ? {...this.formDta} : {account_name:'',account_pix:'',account_cpf:'',account_type:'GCASH',};
				if(this.forData.account_type){
					this.accountType=['GCASH','BANK'].indexOf(this.forData.account_type);
					if(this.accountType==-1){
						this.accountType=0;
					}
				}
				this.isBANK=false;
				this.nowBank = 0;
				if(this.forData.account_type=='BANK'){
					this.isBANK=true;
					this.nowBank=this.forData.account_pix || 0;
				}
				
		  //     console.log(this.forData,newValue);
		      // 这里可以添加更多响应数据变化的逻辑
		    }
		  },
		methods:{
			_click(){
				this.$emit('_click',false)
			},
			chooseType(item,index){
				this.accountType=index;
				this.forData.account_type=item;
				this.isBANK=false;
				if(item=='BANK'){
					this.isBANK=true;
				}
			},
			chooseBank(item,index){
				this.nowBank=index;
				this.forData.account_pix=index;
			},
			_onInput(v,k){
				this.forData[k]=v;
			},
			setBank(){
				let msg = '';
				if(!this.forData.account_name)msg = this.$t('_homeTile_tab._campodeNomereal');
				if(!msg && this.accountType > 0 && this.forData.account_pix < 1){msg = 'Please select a bank'}
				if(!msg && (!this.forData.account_cpf || this.forData.account_cpf.length < 10)){msg = 'Enter the correct account No.'}
				if(!msg && this.accountType == 0 && this.forData.account_cpf.length != 11){msg = 'Enter the correct account No.'}
				if(msg){
					Toast.fail({
						message:this.myLineBreaks(msg),
						duration:0
					});
					setTimeout(()=>{
						Toast.clear()
					},1000)
					return false;
				}

				setBank({...this.forData}).then(({code,msg,data})=>{
					if(code==0){
						Toast.success({
							message:this.myLineBreaks(msg),
							duration:1000
						});
						setTimeout(()=>{
							location.reload();
							this.$attrs.getBank();
							this.$emit('onIsShow',false)
						},1500)
						return false;
					}
					Toast.loading({
						message:this.myLineBreaks(msg),
						duration:1000
					});
				})
			}
		}
	}
</script>
<style>
/* 	.c-s{
		width: 100%;
		height: 100vh;
	} */
	.c-s{
		width: 100vw;
	}
	.c-s .van-overlay{
		width: 100vw;
		/* position: absolute;
		    background-color: rgba(0, 0, 0, .45); */
	}
	.van-field__body input{
		font-size: 0.27rem;
	}
</style>
<style scoped>
	
	.wrapper{
		 display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
		width: 100%;
	}
	 .ant-modal-content {
	    background-color: var(--theme-main-bg-color);
	    border-width: thin;
	    border-style: solid;
	    border-image: initial;
		box-sizing: border-box;
		width: 6.9rem;
	    border-color: var(--theme-color-line);
	    border-radius: 0.2rem;
	    max-height: calc(var(--vh, 1vh)*100 - .1rem);
	    overflow: auto;
	    position: static;
		margin: 0 auto;
	}
	.gD0G2pAAJZZTJ1n0KQXv{
		margin-bottom: .5rem;
	}
	.ant-modal-header{
		 background-color: var(--theme-main-bg-color);
		    border-bottom: none;
		    border-radius: .2rem .2rem 0 0;
		    padding: .2rem .3rem
	}
	.ant-modal-title{
			color: var(--theme-text-color-darken);
		    font-size: .24rem;
		    font-weight: revert;
		    line-height: .34rem;
		    text-align: center;
	}
	.Ou1aviPriFX421w97dGA{
		display: flex;
		align-items: center;
		justify-content: space-between;
		    margin-bottom: .15rem;
		    font-size: .22rem;
			    color: var(--theme-text-color-darken);
	}
	.Ou1aviPriFX421w97dGA .ZaAWGnvFuhPwlBk40od_{
		font-size: .36rem;
		width: .36rem;
		height: .36rem;
		    color: var(--theme-text-color-lighten);
	}
	.Ou1aviPriFX421w97dGA .isShowNum .ZaAWGnvFuhPwlBk40od_{
		color: var(--theme-primary-color);
	}
	.ant-modal-body{
		    padding-top: .2rem !important;
		    padding: .3rem;
	}
	.Kw58s_FCuipHRV_EW4tG{
		    color: var(--theme-text-color-darken);
		    font-size: .22rem;
			display: flex;
	}
	._7B8oTwzAn2VmdNYw3F0z {
	    color: var(--theme-primary-color);
	    cursor: pointer;
	    text-align: right;
	}
	.closeIcon{
		
	}
	.QzRd3YqTnYxG8Latq8fW {
	    background: none;
	    height: .64rem;
	    width: .64rem;
		margin: 0 auto;
	}
	.QzRd3YqTnYxG8Latq8fW img{
		width: 100%;
		height: 100%;
	}
	.JHBAn8W0jkHI1OM_X2fy {
	    border-radius: .14rem;
	    font-size: .24rem;
		width: 100%;
	    height: .7rem;
		 background-color: var(--theme-primary-color);
		border-color: var(--theme-primary-color);
	    line-height: .7rem;
	}
</style>